// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasIsLoading } from "@eisinc/XDL/types";
import { mergeWithCss } from "@eisinc/XDL/Utilities/mergeWithCss";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as React from "react";
import { FC, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface VariantParentProductPriceProps {
    extendedStyles?: VariantParentProductPriceStyle;
}

const mapStateToProps = (state: ApplicationState, props: HasProductContext) => {
    return {
        displayHighLowPricesForParentProducts:
            (getSettingsCollection(state).customSettings as any).displayHighLowPricesForParentProducts === "True",
    };
};

type Props = ReturnType<typeof mapStateToProps> & VariantParentProductPriceProps & HasProductContext & HasIsLoading;

export interface VariantParentProductPriceStyle {
    priceText?: TypographyPresentationProps;
}

export const variantParentProductPriceStyle: VariantParentProductPriceStyle = {
    priceText: {
        variant: "h4",
        forwardAs: "span",
        css: css`
            display: flex;
            margin-bottom: 0;
        `,
    },
};

const VariantParentProductPrice: FC<Props> = ({ productContext, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(variantParentProductPriceStyle, extendedStyles));

    const { lowPrice, highPrice } = productContext.product?.properties || {};

    const displayPrice =
        lowPrice && highPrice && lowPrice !== highPrice ? `${lowPrice} - ${highPrice}` : lowPrice || "";

    return <Typography {...styles.priceText}>{displayPrice}</Typography>;
};

export default withProductContext(connect(mapStateToProps)(VariantParentProductPrice));
